import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@noissue/os-ui';
import type { ReactNode } from 'react';

/** Single shared QueryClient. In Phase 2 this is one of the shell-owned singletons. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster />
    </QueryClientProvider>
  );
}
